import { render, staticRenderFns } from "./ListGroupControl.vue?vue&type=template&id=35cba4db&lang=pug&"
import script from "./ListGroupControl.vue?vue&type=script&lang=js&"
export * from "./ListGroupControl.vue?vue&type=script&lang=js&"
import style0 from "./ListGroupControl.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports